/* eslint-disable max-lines-per-function */
import React from 'react';
export const FeatureRightAlignedImagePreview = (): JSX.Element => (
    <svg xmlns="http://www.w3.org/2000/svg" width="287" height="143" viewBox="0 0 287 143">
        <g data-name="Feature: right aligned image" transform="translate(-830.938 -1580)">
            <g fill="#fff" transform="translate(830.938 1580)">
                <rect width="287" height="143" stroke="none" rx="4" />
                <rect width="286" height="142" x="0.5" y="0.5" fill="none" rx="3.5" />
            </g>
            <g data-name="Group 12456" transform="translate(986.938 1604)">
                <g data-name="Group 8115">
                    <g fill="#edf2f7" stroke="#e2e8f0" strokeWidth="1" data-name="Rectangle 6270">
                        <rect width="107" height="95" stroke="none" rx="4" />
                        <rect width="106" height="94" x="0.5" y="0.5" fill="none" rx="3.5" />
                    </g>
                </g>
                <g fill="none" stroke="#cbd5e1" strokeWidth="2" transform="translate(40.562 34.986)">
                    <g data-name="Rectangle 7981">
                        <rect width="26" height="26" stroke="none" rx="5" />
                        <rect width="24" height="24" x="1" y="1" rx="4" />
                    </g>
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M.91 17.636l4.677-5.247 5.572 4.429"
                        data-name="Path 26926"
                    />
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M4.472 24.406l14.983-16.28 5.847 5.479"
                        data-name="Path 26927"
                    />
                    <g strokeLinecap="round" data-name="Ellipse 1907" transform="translate(5.039 4.333)">
                        <ellipse cx="2.305" cy="2.305" stroke="none" rx="2.305" ry="2.305" />
                        <ellipse cx="2.305" cy="2.305" rx="1.305" ry="1.305" />
                    </g>
                </g>
            </g>
            <text
                fill="#718096"
                fontFamily="Nunito-SemiBold, Nunito"
                fontSize="12"
                fontWeight="600"
                transform="translate(854.938 1616)"
            >
                <tspan x="0" y="0">
                    Heading
                </tspan>
            </text>
            <text
                fill="#a0aec0"
                data-name="copy2"
                fontFamily="Mulish-Regular, Mulish"
                fontSize="10"
                transform="translate(854.938 1638)"
            >
                <tspan x="0" y="0">
                    This is the place for your{' '}
                </tspan>
                <tspan x="0" y="12">
                    content. Did you know{' '}
                </tspan>
                <tspan x="0" y="24">
                    that email marketing has...
                </tspan>
            </text>
            <g data-name="Button - Website Primary Button" transform="translate(854.938 1673)">
                <rect width="50" height="26" fill="#718096" data-name="Button background" rx="4" />
                <text fill="#fff" fontFamily="Mulish-Regular, Mulish" fontSize="10" transform="translate(10 17)">
                    <tspan x="0" y="0">
                        Button
                    </tspan>
                </text>
            </g>
        </g>
    </svg>
);
